import { render, staticRenderFns } from "./ExampleConfig.vue?vue&type=template&id=5c5e1aec&scoped=true&"
import script from "./ExampleConfig.vue?vue&type=script&lang=js&"
export * from "./ExampleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ExampleConfig.vue?vue&type=style&index=0&id=5c5e1aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e1aec",
  null
  
)

export default component.exports